export const ACCENTS = {
  emerald: { label: "Emerald", hsl: "160 84% 39%", fg: "0 0% 100%", hex: "#10B981" },
  gold: { label: "Royal Gold", hsl: "38 92% 50%", fg: "0 0% 10%", hex: "#F59E0B" },
  navy: { label: "Ocean Navy", hsl: "217 91% 60%", fg: "0 0% 100%", hex: "#3B82F6" },
  terracotta: { label: "Terracotta", hsl: "14 80% 53%", fg: "0 0% 100%", hex: "#EA580C" },
  violet: { label: "Deep Violet", hsl: "262 83% 58%", fg: "0 0% 100%", hex: "#8B5CF6" },
};

export const applyAccent = (key) => {
  const a = ACCENTS[key] || ACCENTS.emerald;
  const root = document.documentElement.style;
  root.setProperty("--primary", a.hsl);
  root.setProperty("--primary-foreground", a.fg);
  root.setProperty("--ring", a.hsl);
  root.setProperty("--chart-1", a.hsl);
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", a.hex);
};

export const applyMode = (dark) => {
  document.documentElement.classList.toggle("dark", dark);
};

export const applyBranding = (s, backend) => {
  document.title = s.app_name;
  const link = document.getElementById("app-favicon");
  if (link && s.favicon_url) link.href = `${backend}${s.favicon_url}`;
  const apple = document.getElementById("app-apple-icon");
  if (apple && s.favicon_url) apple.href = `${backend}/api/public/asset/icon192?v=${s.version}`;
  const mf = document.getElementById("app-manifest");
  if (mf) mf.href = `${backend}/api/manifest.json?v=${s.version}`;
  document.querySelector('meta[name="apple-mobile-web-app-title"]')?.setAttribute("content", s.pwa_name);
};
